export const WELLNESS_THRESHOLDS = {
  fatigueHigh: 0.7,
  fatigueCritical: 0.85,
  posturePoor: 50,
  postureCritical: 30,
  onlineTimeoutMinutes: 5,
  sessionBreakAlertMinutes: 30,
};

export const WELLNESS_DEFAULTS = {
  postureScore: null as number | null,
  fatigueIndex: null as number | null,
  emotionState: null as string | null,
  emotionConfidence: null as number | null,
};

export const EMOTION_SCORES: Record<string, number> = {
  Focused: 90,
  Happy: 95,
  Engaged: 85,
  Neutral: 70,
  Confused: 50,
  Tired: 40,
  Stressed: 35,
  Frustrated: 30,
};
